export function scrollToId(id, offset = -100) {
  const element = document.getElementById(id);
  if (!element) return;

  const windowOffset = window.scrollY || window.pageYOffset;
  const { top } = element.getBoundingClientRect();
  const scrollY = top;

  window.scroll({
    top: windowOffset + scrollY + offset,
    behavior: 'smooth',
    left: 0
  });
}
